export var IVRJourneyEventType;
(function (IVRJourneyEventType) {
    IVRJourneyEventType[IVRJourneyEventType["INCOMING_CALL"] = 1400] = "INCOMING_CALL";
    IVRJourneyEventType[IVRJourneyEventType["ROUTE_TO_IVR"] = 1401] = "ROUTE_TO_IVR";
    IVRJourneyEventType[IVRJourneyEventType["ROUTE_TO_QUEUE"] = 1402] = "ROUTE_TO_QUEUE";
    IVRJourneyEventType[IVRJourneyEventType["USER_INPUT"] = 1404] = "USER_INPUT";
    IVRJourneyEventType[IVRJourneyEventType["WEBHOOK_SENT"] = 1405] = "WEBHOOK_SENT";
    IVRJourneyEventType[IVRJourneyEventType["EXTERNAL_NUMBER"] = 1217] = "EXTERNAL_NUMBER";
})(IVRJourneyEventType || (IVRJourneyEventType = {}));
//# sourceMappingURL=ivr-journey-event-type.enum.js.map